import Breadcrumb from 'components/Navigation/Breadcrumb';
import React from 'react';
import male from '../../../../assets/male-big.png';
import Button from 'components/Form/Button';
import {
  useGetProspectActivities,
  useGetProspectDetails
} from 'common/queries-and-mutations/admin/prospect';
import { Link, useParams } from 'react-router-dom';
import { Loader } from 'components/Loader';
import { truncateText } from 'utils';

export default function ProspectDetails() {
  const { prospectId } = useParams();

  const { data, isLoading, isFetched } = useGetProspectDetails({
    prospectId: prospectId!
  });

  const { data: activities } = useGetProspectActivities({
    prospectId: prospectId!
  });

  if (isLoading && isFetched) {
    return (
      <div className="mt-40 flex flex-col items-center justify-center">
        <Loader color={'#FF6606'} height={50} width={50} />
      </div>
    );
  }

  return (
    <div>
      <Breadcrumb title="Prospect Profile" />
      <div className="mt-5">
        <div className="mb-5 flex flex-row rounded bg-white">
          <div className="flex w-1/5 flex-col items-center justify-center border-r px-6">
            <div className="flex flex-col items-center justify-center gap-3">
              <img src={male} />
              <p className="text-xl font-bold text-[#353535]">{`${data?.otherNames} ${data?.surname}`}</p>
            </div>
          </div>
          <div className="w-full">
            <div className="border-b border-[#E5E5E5]">
              <div className="mt-3 grid grid-cols-4 gap-x-16 px-6">
                <div className="col-span-1 px-8 py-6">
                  <p className="text-[10px] font-normal text-[#7A7C87]">Name</p>
                  <p className="mt-1 text-sm font-normal text-[#353535]">
                    {`${data?.otherNames} ${data?.surname}`}
                  </p>
                </div>
                <div className="col-span-1 px-8 py-4">
                  <p className="text-[10px] font-normal text-[#7A7C87]">
                    Phone Number
                  </p>
                  <p className="mt-1 text-sm font-normal text-[#353535]">
                    {data?.mobileNo}
                  </p>
                </div>
                <div className="col-span-1 px-8 py-6">
                  <p className="text-[10px] font-normal text-[#7A7C87]">
                    Gender
                  </p>
                  <p className="mt-1 text-sm font-normal text-[#353535]">
                    {data?.gender ?? ''}
                  </p>
                </div>
                <div className="col-span-1 px-8 py-4">
                  <p className="text-[10px] font-normal text-[#7A7C87]">
                    Email address
                  </p>
                  <p className="mt-1 text-sm font-normal text-[#353535]">
                    {data?.emailAddress ?? ''}
                  </p>
                </div>
              </div>
            </div>
            <div className="border-b border-[#E5E5E5]">
              <div className="grid grid-cols-4 gap-x-16 px-6">
                <div className="col-span-1 px-8 py-4">
                  <p className="text-[10px] font-normal text-[#7A7C87]">
                    State
                  </p>
                  <p className="mt-1 text-sm font-normal text-[#353535]">
                    {data?.state ?? ''}
                  </p>
                </div>
                <div className="col-span-1 px-8 py-4">
                  <p className="text-[10px] font-normal text-[#7A7C87]">City</p>
                  <p className="mt-1 text-sm font-normal text-[#353535]">
                    {data?.city ?? ''}
                  </p>
                </div>

                <div className="col-span-1 px-8 py-4">
                  <p className="text-[10px] font-normal text-[#7A7C87]">
                    Home Address
                  </p>
                  <p className="mt-1 text-sm font-normal text-[#353535]">
                    {data?.address ?? ''}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="my-3 grid grid-cols-1 gap-4 tablet:grid-cols-3">
          <Link to={`/admin/prospects/assign-agent/${prospectId}`}>
            <Button
              variant="secondary"
              size="custom"
              className="h-14 w-[23.5rem] rounded border-none bg-[#00B388] p-2.5 font-medium text-white hover:bg-[#00B388]"
              label="Assign To Agent"
              type="button"
            ></Button>
          </Link>

          <Link to={`/admin/prospects/notes/${prospectId}`}>
            <Button
              variant="secondary"
              size="custom"
              className="h-14 w-[23.5rem] rounded border-none bg-[#FF6606] p-2.5 font-medium text-white"
              label="Notes"
              type="button"
            ></Button>
          </Link>
        </div>

        <div className="relative overflow-x-auto bg-white pb-11 sm:rounded-lg">
          <div className="mb-3 flex items-center justify-between">
            <div className="p-5 text-left text-lg font-semibold text-gray-900">
              Activity Summary
            </div>
          </div>
          {data?.hasActivity && (
            <div className="mx-9">
              <ol className="relative border-l-2 border-[#EAEEFD]">
                <div>
                  {(activities?.activities ?? []).map(activity => (
                    <ol
                      className="relative border-l-2 border-[#EAEEFD]"
                      key={activity.prospectActivity_id}
                    >
                      <ul>
                        <li className="mb-[25px] ml-4 border-b border-[#F3F5F6]">
                          <div className="absolute -left-2 mt-1.5 h-3 w-3 rounded-full border border-white bg-[#FF6606]" />
                          <div className="flex items-center justify-between">
                            <div className="mb-1 text-sm font-normal leading-none text-[#353535] dark:text-gray-500">
                              {truncateText(activity.narration, 100)}
                            </div>
                            <span className="text-xs font-normal text-[#353535]">
                              {activity.createdDate}
                            </span>
                          </div>
                        </li>
                      </ul>
                    </ol>
                  ))}
                </div>
              </ol>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
